import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ManufacturerPreferencesPage } from '@/areas/settings/part-intelligence/Settings/ManufacturerPreferencesPage/ManufacturerPreferencesPage';
import { canViewDesignSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/manufacturer-preferences')({
    staticData: {
        access: { permissions: canViewDesignSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ManufacturerPreferencesPage />;
}
